import { EuiFlexGroup, EuiFlexItem, EuiIcon, EuiText } from '@elastic/eui'

import { LoadingSpinner } from '@components/layout'

type SelectionBoxShowMoreItemProps = {
    onClick?: () => void
    isLoading?: boolean
}

export const SelectionBoxShowMoreItem = ({
    onClick,
    isLoading,
}: SelectionBoxShowMoreItemProps) => {
    return (
        <EuiFlexGroup
            gutterSize="s"
            style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                background: '#fff',
                left: 0,
                top: 1,
                borderRadius: 4,
            }}
            justifyContent="center"
            alignItems="center"
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                if (onClick) {
                    onClick()
                }
            }}
        >
            {!isLoading && (
                <>
                    <EuiFlexItem grow={false}>
                        <EuiText color="accent" size="xs">
                            Show more...
                        </EuiText>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiIcon type="arrowDown" color="accent" size="s" />
                    </EuiFlexItem>
                </>
            )}
            {isLoading && (
                <EuiFlexItem grow={false}>
                    <LoadingSpinner />
                </EuiFlexItem>
            )}
        </EuiFlexGroup>
    )
}
